export default __webpack_public_path__ + "static/media/tmdb_logo.98dbf836.svg";